export const LAMBDATEST_DELETE_BUILD_LOADING = `LAMBDATEST_DELETE_BUILD_LOADING`;
export const LAMBDATEST_DELETE_BUILD_SUCCESS = `LAMBDATEST_DELETE_BUILD_SUCCESS`;
export const LAMBDATEST_DELETE_BUILD_FAILED = `LAMBDATEST_DELETE_BUILD_FAILED`;
export const LAMBDATEST_DELETE_BUILD_CLEAR = `LAMBDATEST_DELETE_BUILD_CLEAR`;
